const binding = { modules: {}, dataActions: {} };

    const registerActionId = (actionPath) => {
        if (binding.dataActions[actionPath] &&
            binding.dataActions[actionPath].default &&
            binding.dataActions[actionPath].default.prototype &&
            binding.dataActions[actionPath].default.prototype.id) {
            binding.dataActions[binding.dataActions[actionPath].default.prototype.id] = binding.dataActions[actionPath];
        } else {
            Object.keys(binding.dataActions[actionPath] || {}).forEach(exportName => {
                if (binding.dataActions[actionPath][exportName] &&
                    binding.dataActions[actionPath][exportName].prototype &&
                    binding.dataActions[actionPath][exportName].prototype.Action) {
                    binding.dataActions[binding.dataActions[actionPath][exportName].prototype.id] = binding.dataActions[actionPath][exportName];
                }
            })
        }
    };

    const registerSanitizedActionPath = (sanitizedActionPath, dataAction) => {
        if (process.env.NODE_ENV === 'development') {
            if (!dataAction.default) {
                throw new Error('Data action path does not have a default export');
            }
            if (!(dataAction.default.prototype.id && binding.dataActions[dataAction.default.prototype.id]) || !binding.dataActions[sanitizedActionPath]) {
                binding.dataActions[sanitizedActionPath] = dataAction;
            }
        } else {
            binding.dataActions[sanitizedActionPath] = dataAction;
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
    };
    

        {   
            const actionPath = 'actions/add-order-template-to-cart-override.action';
            binding.dataActions[actionPath] = require('partner/actions/add-order-template-to-cart-override.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-availabilities-cartlines-override.action';
            binding.dataActions[actionPath] = require('partner/actions/get-availabilities-cartlines-override.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-delivery-options-for-cart-override.action';
            binding.dataActions[actionPath] = require('partner/actions/get-delivery-options-for-cart-override.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-email-subscriptions.action';
            binding.dataActions[actionPath] = require('partner/actions/get-email-subscriptions.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-inventory-uom.action';
            binding.dataActions[actionPath] = require('partner/actions/get-inventory-uom.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-sales-order-detail-by-salesid.action';
            binding.dataActions[actionPath] = require('partner/actions/get-sales-order-detail-by-salesid.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-simple-products.override.action';
            binding.dataActions[actionPath] = require('partner/actions/get-simple-products.override.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-uom.action';
            binding.dataActions[actionPath] = require('partner/actions/get-uom.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-zone-prices.action';
            binding.dataActions[actionPath] = require('partner/actions/get-zone-prices.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/past-due-notice.action';
            binding.dataActions[actionPath] = require('partner/actions/past-due-notice.action');
            registerActionId(actionPath);
        }

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.packageDataActions = {};
        window.__bindings__.packageDataActions['__local__'] = {
            ...binding.dataActions
        };